import styled from "styled-components";

export const FooterText = styled.div`
    margin-right: 24px;
`;
